import { useEffect, useState } from "react";
import { Toaster, toast } from 'react-hot-toast';

import Heading from './Heading';
import Loader from './Loader';
import Icon from './Icon';

import '../Styles/ContactMe.css';
import '../Styles/PersonalLinks.css';
import AddLink from "./AddLink";

const toaster = ({ dark = true, message, error = false }) => {
    !error
        ? toast.success(message, {
            style: {
                border: '1px solid #61D245',
                padding: '0.85rem',
                color: '#61D245',
                fontWeight: 'bold',
                borderRadius: '5px',
                backgroundColor:
                    'hsla(195, 6%, 6%, 0.95)',
                boxShadow: `0 0 10px ${dark
                    ? 'hsla(197, 24%, 94%, 0.7)'
                    : 'hsla(195, 6%, 6%, 0.95)'
                    }`,
            },
            iconTheme: {
                secondary: 'hsl(197, 24%, 94%)',
            },
        })
        : toast.error(message, {
            style: {
                border: '1px solid hsl(359, 77%, 56%)',
                padding: '0.85rem',
                color: 'hsl(359, 77%, 56%)',
                fontWeight: 'bold',
                borderRadius: '5px',
                backgroundColor: dark
                    ? 'hsla(195, 6%, 6%, 0.85)'
                    : 'hsla(195, 100%, 100%, 0.85)',
                boxShadow: `0 0 10px ${dark
                    ? 'hsla(197, 24%, 94%, 0.7)'
                    : 'hsla(195, 6%, 6%, 0.95)'
                    }`,
            },
            iconTheme: {
                primary: 'hsl(359, 77%, 56%)',
                secondary: 'hsl(197, 24%, 94%)',
            },
        });
};

const PersonalLinks = () => {
    // Notion
    const [loading, setLoading] = useState(false);
    const [personalLinks, setPersonalLinks] = useState({});
    const [isAddLinkModalOpen, setIsAddLinkModalOpen] = useState(false);

    const fetchNotionData = async () => {
        setLoading(true);

        const apiUrl = `${process.env.REACT_APP_API
            ? process.env.REACT_APP_API
            : ''
            }/api/notion?onlyLinks=true`;

        fetch(apiUrl)
            .then(async (response) => {
                const body = await response.json();
                setPersonalLinks(body.personalLinks);
            })
            .catch((e) => {
                console.log(e);
                toaster({ error: true, message: e.message || "Error" });
            })
            .finally(() => setLoading(false));
    };

    const addLink = ({
        title,
        link
    }) => {
        setLoading(true);

        const apiUrl = `${process.env.REACT_APP_API
            ? process.env.REACT_APP_API
            : ''
            }/api/notion-links-update`;

        fetch(apiUrl, {
            method: 'POST',
            body: JSON.stringify({
                title,
                link
            })
        }).then(() => {
            setPersonalLinks((currentLinks) => [
                ...currentLinks,
                { title, link }
            ]);
        }).catch((e) => {
            toaster({ error: true, message: e.message || "Error" });
        }).finally(() => {
            setLoading(false);
            setIsAddLinkModalOpen(false)
        });
    }

    const deleteLink = (id) => {
        setLoading(true);

        const apiUrl = `${process.env.REACT_APP_API
            ? process.env.REACT_APP_API
            : ''
            }/api/notion-links-update`;

        fetch(apiUrl, {
            method: 'DELETE',
            body: JSON.stringify({
                id
            })
        }).then(() => {
            setPersonalLinks((currentLinks) => currentLinks?.filter(link => link.id !== id));
        }).catch((e) => {
            toaster({ error: true, message: e.message || "Error" });
        }).finally(() => setLoading(false));
    }

    useEffect(() => {
        fetchNotionData();
    }, []);

    return (
        <>
            <Toaster />
            <AddLink
                show={isAddLinkModalOpen}
                setShow={setIsAddLinkModalOpen}
                toaster={toaster}
                addLink={addLink}
            />
            <main className="personal-links-page">
                <Heading heading='Personal Links' />
                <Loader show={loading} />
                {!loading && personalLinks?.length
                    ? (
                        <>
                            <div className="personal-links">
                                {personalLinks?.map((personalLink, index) => (
                                    <div key={index} className="personal-link-wrapper">
                                        <Icon
                                            icon='fa-solid fa-trash'
                                            iconType='fontawesome'
                                            className='icon delete'
                                            onClick={() => deleteLink(personalLink.id)}
                                        />
                                        <a rel="noreferrer" key={index} className="personal-link" target="_blank" href={personalLink?.link}>
                                            <span className='index'>
                                                {index >= 9 ? "" : "0"}{index + 1}.{"  "}
                                            </span>
                                            {personalLink.title}
                                            <span className="internal">{" - "}{personalLink.link}</span>
                                        </a>
                                        <Icon
                                            icon='fa-solid fa-link'
                                            iconType='fontawesome'
                                            className='icon link'
                                        />
                                    </div>
                                ))}
                            </div>
                            <br />

                        </>
                    )
                    : (
                        <h1 className="error">No links found!</h1>
                    )
                }
                <button
                    className={'contact-btn btn'}
                    onClick={() => setIsAddLinkModalOpen(true)}
                >
                    <Icon
                        icon='fa-solid fa-plus'
                        iconType='fontawesome'
                        className='icon link'
                    />{' '}
                    Add Link
                </button>
            </main>
        </>
    )
};

export default PersonalLinks;
